import request from '@hotmart/request'
import { IExtensionsSubscription, IExtensionsSubscriptionQuota } from './extensions-subscriptions.interfaces'
import { EXTENSIONS_REQUEST_IDENTIFIERS } from './extensions-subscriptions.constants'
import './extensions-subscriptions.requests'

export const getExtensionsSubscriptions = async (): Promise<IExtensionsSubscription[]> =>
  await request(EXTENSIONS_REQUEST_IDENTIFIERS.GET_EXTENSIONS_SUBSCRIPTIONS)

export const getExtensionsSubscriptionsQuota = async (): Promise<IExtensionsSubscriptionQuota[]> =>
  await request(EXTENSIONS_REQUEST_IDENTIFIERS.GET_EXTENSIONS_SUBSCRIPTION_QUOTA)
